;
// Handles tasks related to the direct invite questionnaire
(function() {
    var snDirectAdModule = function () {
      var props = {
        loginContainerSelector: null,
        checkedEmails: {}
      };

      return {
        toggleLogin: function(emailExists) {
          if ( null == props.loginContainerSelector ) {
            return null;
          }
          if ( emailExists ) {
            $(props.loginContainerSelector).show();
          } else {
            $(props.loginContainerSelector).hide();
          }
          return emailExists;
        },

        onEmailResults: function(email, data) {
          props.checkedEmails[email] = data.exists;
          this.toggleLogin(props.checkedEmails[email]);
          return props.checkedEmails[email];
        },

        checkEmail: function(email) {
          if ( email ) {
            var email = email.trim().toLowerCase();
            if ( props.checkedEmails.hasOwnProperty(email) ) {
              this.toggleLogin(props.checkedEmails[email]);
            } else {
              if ( email.length > 0 && email.indexOf('@') > 0 && email.indexOf('.') > 0 ) {
                $.get('/public/users/checkemail', {email: email}, (function(data){
                  this.onEmailResults(email, data);
                }).bind(this));
              }
            }
          }
          return email;
        },

        onEmailChanged: function(e) {
          this.checkEmail($(e.target).val());
        },

        setupHooks: function(emailSelector, setupTimers) {
          $(document).on('keyup', emailSelector, this.onEmailChanged.bind(this));
          if ( setupTimers ) {
            setInterval((function(){
              this.checkEmail($(emailSelector).val());
            }).bind(this),250);
          }
        },

        init: function(emailSelector, loginContainerSelector, setupTimers) {
          props.checkedEmails = {};
          props.loginContainerSelector = loginContainerSelector;
          this.setupHooks(emailSelector, setupTimers);
        }
      };
  }();

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = snDirectAdModule;
  } else {
    window.snDirectAdModule = snDirectAdModule;
  }
})();    